import CircularProgress from '@material-ui/core/CircularProgress';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/styles/createStyles';
import makeStyles from '@material-ui/styles/makeStyles';
import React, { useEffect, useState } from 'react';

export const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        display: 'grid',
        placeItems: 'center',
        height: '100vh',
        width: '100vw',
    }
}))

type Props = {
    loading?: boolean
    children?: React.ReactNode
    screenId: string
}

export function FullscreenLoading({ children, loading = true, screenId }: Props) {
    const classes = useStyles();
    const [show, setShow] = useState(false)
    useEffect(() => {
        const id = setTimeout(() => {
            setShow(true)
        }, 1000)
        return () => {
            clearTimeout(id)
        }
    }, [setShow])
    //console.log(screenId)
    return !loading ? <>{children}</> : (
        <div className={classes.root}>
            {show ? <CircularProgress /> : null}
        </div>
    )
}
